<template>
  <div class="user-info-card">
    <v-card color="white" min-height="85">
      <v-row class="px-8 justify-center align-center no-flex">
        <v-col class="name fw-600 fs-18" cols="12" :xs="12" sm="4" :md="4">
          {{ item.name }}
        </v-col>
        <v-col class="email font-weight-bold fs-18" cols="12" :xs="12" sm="5" :md="4">
          {{ item.email }}
        </v-col>
        <v-col class="action-icons text-right">
          <!-- <v-btn icon @click="$emit('user-info-card', { action: 'edit', user: item })">
            <v-icon>far fa-edit</v-icon>
          </v-btn> -->
          <v-btn
            :loading="isAddUserFormLoading"
            :disabled="item.id === this.$store.getters.user.id"
            icon
            @click="$emit('user-info-card', { action: 'delete', user: item })"
          >
            <v-icon color="error">far fa-trash-alt</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>
<script>
export default {
  name: "UserInfoCard",
  data() {
    return {
      isCurrentUser: false
    };
  },
  props: {
    item: {
      required: true,
      type: Object
    },
    isAddUserFormLoading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.user-info-card {
  .v-card {
    z-index: 4;
    border-radius: 11px;
    .row {
      min-height: inherit;
      .email {
        color: #747474;
      }
    }
  }
}
</style>
